import {
  HUD1_MI_MONTHS_OV_KEY,
  MI_LOAN_KEYS,
  miPrepaidKey,
} from './mortgageInsurance.constants'

export type MortgageInsuranceFieldKey = {
  MonthsInAdvanceKey: string
  feeMultipleKey: string
  PremiumOVKey: string
  PremiumPBSDesired: string
  PremiumPOCKey: string
  PremiumNetFromWireKey: string
  PremiumPaidByOtherTypeKey: string
  PremiumPaidToTypeKey: string
  PremiumPointsAndFeesAmountOV: string
  monthKey: string
  reserveOVKey: string
  feeSKey: string
  ReservesPOCKey: string
  ReservesPaidByOtherTypeKey: string
  ReservesPointsAndFeesAmountOV: string
  QMATRNotesKey: string
  PeriodicPaymentAmountKey: string
  DisbursementSchedKey: string
  DisbursementStartPurKey: string
  CushionKey: string
  CushionOVKey: string
  DisbursementStartYearKey: string
  DisbursementPeriodsKey: string
  DisbursementListKey: string
}

const field = (data: Record<string, any>, key: string) => ({ value: data[key], key })

export const buildMortgageInsuranceModalData = (
  data: Record<string, any>,
  keys: MortgageInsuranceFieldKey,
) => ({
  pmiType: field(data, MI_LOAN_KEYS.pmiType),
  miPremiumPct: field(data, MI_LOAN_KEYS.miPremiumPct),
  miPremiumAmt: field(data, MI_LOAN_KEYS.miPremiumAmt),
  miPremiumEstimatePct: field(data, MI_LOAN_KEYS.miPremiumEstimatePct),
  miMonthsOV: field(data, HUD1_MI_MONTHS_OV_KEY),
  monthsInAdvance: field(data, keys.MonthsInAdvanceKey),
  payment: field(data, keys.feeMultipleKey),
  premiumOV: field(data, keys.PremiumOVKey),
  premiumPBS: field(data, keys.PremiumPBSDesired),
  premiumPOC: field(data, keys.PremiumPOCKey),
  netFromWire: field(data, keys.PremiumNetFromWireKey),
  premiumPaidByOther: field(data, keys.PremiumPaidByOtherTypeKey),
  paidTo: field(data, keys.PremiumPaidToTypeKey),
  premPointsAndFeesOV: field(data, keys.PremiumPointsAndFeesAmountOV),
  premiumGFEDisclosed: field(data, miPrepaidKey('PremiumGFEDisclosedAmount')),
  monthlyMiPremiumYrs1Pct: field(data, MI_LOAN_KEYS.monthlyMiPremiumYrs1Pct),
  monthlyMiPremiumYrs1Amt: field(data, MI_LOAN_KEYS.monthlyMiPremiumYrs1Amt),
  monthlyMiPremiumYrs1EstimatePct: field(data, MI_LOAN_KEYS.monthlyMiPremiumYrs1EstimatePct),
  monthlyMiPremiumYrs2Pct: field(data, MI_LOAN_KEYS.monthlyMiPremiumYrs2Pct),
  monthlyMiPremiumYrs2Amt: field(data, MI_LOAN_KEYS.monthlyMiPremiumYrs2Amt),
  monthlyMiPremiumYrs2EstimatePct: field(data, MI_LOAN_KEYS.monthlyMiPremiumYrs2EstimatePct),
  ltvCutoffPct: field(data, MI_LOAN_KEYS.ltvCutoffPct),
  ltvCutoffMonth: field(data, MI_LOAN_KEYS.ltvCutoffMonth),
  prepaidMiWillBe: field(data, MI_LOAN_KEYS.prepaidMiWillBe),
  periodicPayment: field(data, keys.PeriodicPaymentAmountKey),
  monthsInReserve: field(data, keys.monthKey),
  reserveOV: field(data, keys.reserveOVKey),
  reservePBS: field(data, keys.feeSKey),
  reservesPOC: field(data, keys.ReservesPOCKey),
  reservePaidByOther: field(data, keys.ReservesPaidByOtherTypeKey),
  resPointsAndFeesOV: field(data, keys.ReservesPointsAndFeesAmountOV),
  reservesGFEDisclosed: field(data, miPrepaidKey('ReservesGFEDisclosedAmount')),
  disbSched: field(data, keys.DisbursementSchedKey),
  starting: field(data, keys.DisbursementStartPurKey),
  cushion: field(data, keys.CushionKey),
  cushionOV: field(data, keys.CushionOVKey),
  disbStartYear: field(data, keys.DisbursementStartYearKey),
  disbPeriods: field(data, keys.DisbursementPeriodsKey),
  disbList: field(data, keys.DisbursementListKey),
  atrNotes: field(data, keys.QMATRNotesKey),
})
